// 🔥 WENDELLA SWATCHES - SISTEMA UNIVERSAL MEJORADO
const collectionHandle = window.location.pathname.split('/')[2];

// Detectar automáticamente el número total de páginas
async function getTotalPages() {
  try {
    const response = await fetch(`/collections/${collectionHandle}/products.json?limit=1`);
    const data = await response.json();
    
    // Shopify no devuelve total en la API, así que hacemos una estimación conservadora
    // Empezamos con 10 páginas y ajustamos según necesidad
    return 10;
  } catch (error) {
    console.warn('⚠️ Error detectando páginas, usando default:', error);
    return 10;
  }
}

// Generar URLs dinámicamente
function generateUrls(totalPages) {
  const urls = [];
  const limit = 500; // Aumentado de 250 a 500 por página
  
  for (let page = 1; page <= totalPages; page++) {
    urls.push(`/collections/${collectionHandle}/products.json?page=${page}&limit=${limit}`);
  }
  
  console.log(`🔗 URLS GENERADAS: ${urls.length} páginas con limit ${limit}`);
  return urls;
}

// Fetch mejorado con retry y mejor manejo de errores
async function fetchWithRetry(url, retries = 2) {
  for (let i = 0; i <= retries; i++) {
    try {
      const response = await fetch(url);
      if (response.ok) {
        return await response.json();
      }
      throw new Error(`HTTP ${response.status}`);
    } catch (error) {
      if (i === retries) {
        console.warn(`❌ Error final en ${url}:`, error);
        return { products: [] }; // Retornar estructura vacía en lugar de fallar
      }
      console.warn(`⚠️ Retry ${i + 1} para ${url}`);
      await new Promise(resolve => setTimeout(resolve, 500)); // Esperar 500ms antes del retry
    }
  }
}

async function createSwatches() {
  console.log('🚀 INICIANDO SWATCHES WENDELLA MEJORADO...');
  
  try {
    // Detectar número de páginas automáticamente
    const totalPages = await getTotalPages();
    const urls = generateUrls(totalPages);
    
    console.log('📡 FETCHING PRODUCTOS...');
    const startTime = Date.now();
    
    // Fetch todos los URLs con mejor control de errores
    const responses = await Promise.all(
      urls.map(url => fetchWithRetry(url))
    );
    
    // Combinar todos los productos válidos
    const combinedArray = [];
    let totalFetched = 0;
    
    responses.forEach((data, index) => {
      if (data?.products) {
        combinedArray.push(...data.products);
        totalFetched += data.products.length;
        console.log(`📄 Página ${index + 1}: ${data.products.length} productos`);
      }
    });
    
    const endTime = Date.now();
    console.log(`✅ FETCH COMPLETADO: ${totalFetched} productos en ${endTime - startTime}ms`);
    
    if (combinedArray.length === 0) {
      console.error('❌ No se obtuvieron productos. Revisar configuración.');
      return;
    }
    
    // Iniciar procesamiento de swatches
    assignSwatches(combinedArray);
    
  } catch (error) {
    console.error('💥 ERROR CRÍTICO en createSwatches:', error);
  }
}

function assignSwatches(combinedArray) {
  console.log('🎨 PROCESANDO SWATCHES...');
  
  // Buscar productos en el DOM
  const productElements = document.querySelectorAll('.thumbnail');
  console.log('📍 PRODUCTOS EN DOM:', productElements.length);
  
  if (productElements.length === 0) {
    console.warn('⚠️ No se encontraron elementos .product-thumbnail en el DOM');
    return;
  }
  
  productElements.forEach((element, index) => {
    // Obtener título del producto desde el DOM - debugging múltiples selectores
    let titleElement = element.querySelector('.product-info-file .title');
    
    // Fallbacks para diferentes estructuras
    if (!titleElement) titleElement = element.querySelector('.product-details .title');
    if (!titleElement) titleElement = element.querySelector('.title');
    if (!titleElement) titleElement = element.querySelector('.product_name');
    if (!titleElement) titleElement = element.querySelector('a[href*="/products/"]');
    if (!titleElement) titleElement = element.querySelector('.product-info__caption .title');
    
    if (!titleElement) {
      console.warn('⚠️ No se encontró título para producto', index);
      console.log('DOM structure:', element.innerHTML.substring(0, 500) + '...');
      return;
    }
    
    const productTitle = titleElement.textContent.trim();
    const baseName = productTitle.split(' - ')[0].trim();
    
    // Verificar si ya fue procesado
    if (element.hasAttribute('data-swatches-processed')) {
      return;
    }
    
    console.log(`🔍 PROCESANDO: "${baseName}"`);
    
    // Crear container de swatches si no existe
    const productInfo = element.querySelector('.product-info-file');
    const priceElement = productInfo?.querySelector('.price, .product_price');
    
    if (!productInfo || !priceElement) {
      console.warn('⚠️ No se encontró product-info o price para:', baseName); 
      return;
    }
    
    // Crear grid de colores único
    const productId = `swatch-${index}`;
    let colorGrid = productInfo.querySelector('.color-swatches');
    
    if (!colorGrid) {
      colorGrid = document.createElement('div');
      colorGrid.className = 'color-swatches';
      colorGrid.id = `colorgrid${productId}`;
      colorGrid.style.cssText = `
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin: 10px 0;
        align-items: center;
      `;
      priceElement.parentNode.insertBefore(colorGrid, priceElement);
    }
    
    // Cambiar título a nombre base
    titleElement.textContent = baseName;
    
    let swatchCount = 0;
    const processedColors = new Set(); // Para evitar duplicados más eficientemente
    
    // Buscar todas las variantes para este nombre base
    combinedArray.forEach((product) => {
      const productBaseName = product.title.split(' - ')[0].trim();
      
      if (productBaseName === baseName) {
        const colorName = product.title.split(' - ')[1]?.trim() || 'Default';
        const colorHandleized = colorName.toLowerCase().replace(/ /g, '-').replace(/\//g, '-');
        
        // Solo añadir si no existe ya este color (usando Set para mejor performance)
        if (!processedColors.has(colorHandleized)) {
          processedColors.add(colorHandleized);
          
          const productUrl = `/products/${product.handle}`;
          const productImage = product.images[0]?.src || '';
          
          const swatchItem = `
            <a href="${productUrl}" class="swatch-link" data-color="${colorName}" data-product-id="${product.id}">
              <span class="color-swatch" 
                    style="
                      display: inline-block;
                      width: 44px;
                      height: 44px;
                      border: 2px solid #ddd;
                      border-radius: 50%;
                      background-image: url('${productImage}');
                      background-size: cover;
                      background-position: center;
                      transition: all 0.3s ease;
                      cursor: pointer;
                      margin: 2px;
                    " 
                    title="${product.title}"
                    data-variant-image="${productImage}&width=500">
                <span class="visually-hidden">${colorName}</span>
              </span>
            </a>`;
          
          colorGrid.insertAdjacentHTML("beforeend", swatchItem);
          swatchCount++;
          
          // LÓGICA DE 4 SWATCHES VISIBLES
          const currentSwatches = colorGrid.querySelectorAll(".swatch-link");
          
          if (swatchCount > 4) {
            // Ocultar del 5to en adelante
            currentSwatches.forEach((swatch, swatchIndex) => {
              if (swatchIndex >= 4) {
                swatch.style.display = "none";
              }
            });
            
            // Añadir contador si es necesario
            if (swatchCount === 5) {
              colorGrid.insertAdjacentHTML(
                "beforeend",
                '<span class="morecolorsct" style="cursor:pointer; background: #f0f0f0; border: 1px solid #ccc; border-radius: 50%; width: 44px; height: 44px; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; margin: 2px;"><span class="colornumber">+1</span></span>'
              );
            } else if (swatchCount > 5) {
              const moreColorsCt = colorGrid.querySelector(".morecolorsct");
              if (moreColorsCt) {
                const extraCount = swatchCount - 4;
                moreColorsCt.innerHTML = `<span class="colornumber">+${extraCount}</span>`;
              }
            }
          }
        }
      }
    });
    
    console.log(`✅ ${baseName}: ${swatchCount} colores agregados`);
    
    // Marcar como procesado
    element.setAttribute('data-swatches-processed', 'true');
  });
  
  assignViewMoreSwatches();
  console.log('🎉 SWATCHES COMPLETADOS!');
}

const assignViewMoreSwatches = () => {
  const buttons = document.querySelectorAll("span.morecolorsct");
  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const parent = this.parentNode;
      const swatches = parent.querySelectorAll(".swatch-link");
      swatches.forEach((swatch) => {
        swatch.style.display = "inline-block";
      });
      btn.style.display = "none";
    });
  });
};

// Inicialización mejorada con loading state
function initializeSwatches() {
  console.log('🎯 INICIALIZANDO SWATCHES...');
  
  // Verificar que estamos en una página de colección
  if (!collectionHandle || collectionHandle === 'undefined') {
    console.warn('⚠️ No se detectó collection handle válido');
    return;
  }
  
  // Mostrar indicador de carga (opcional)
 /* const loadingIndicator = document.createElement('div');
  loadingIndicator.id = 'swatches-loading';
  loadingIndicator.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #333;
    color: white;
    padding: 10px 15px;
    border-radius: 5px;
    font-size: 12px;
    z-index: 9999;
  `;*/
  //loadingIndicator.textContent = '🔄 Cargando swatches...';
  //document.body.appendChild(loadingIndicator);
  
  // Iniciar proceso
  createSwatches().finally(() => {
    // Remover indicador de carga
    setTimeout(() => {
      const indicator = document.getElementById('swatches-loading');
      if (indicator) {
        indicator.remove();
      }
    }, 2000);
  });
}

// Inicializar cuando DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initializeSwatches, 500);
  });
} else {
  setTimeout(initializeSwatches, 500);
} 